module.exports = __webpack_public_path__ + "img/ced-architectural-illustration.5c1e8d70.jpg";